import { SimpleSlider, FluidSlider, GalleryProgressSlider } from '../../__utils/sliders';
import GalleryLightbox from '../../__page/lightboxGallery';

const $ = jQuery.noConflict();

let resizeInterval = null;
let resizeTimeout = null;

const setGalleryArrowPos = function(slider, sliderSelector) {
    $(sliderSelector).slick('setPosition');

    const sliderPrev = slider.querySelector('.slick-prev');
    const sliderNext = slider.querySelector('.slick-next');
    const activeSlide = slider.querySelector('.slick-active');
    let activeSlideCenter = activeSlide.offsetTop + (activeSlide.offsetHeight / 2);
    const activeSlideLeft = activeSlide.getBoundingClientRect().left;
    const activeSlideRight = activeSlideLeft + activeSlide.offsetWidth;
    const sliderNextRight = ((document.body.offsetWidth - activeSlideRight) - sliderNext.offsetWidth);
    const sliderPrevLeft = activeSlideLeft - sliderPrev.offsetWidth;

    const sliderCaption = slider.querySelector('.gallery-slider__caption');

    if(sliderCaption !== null) {
        const activeSlideImage = activeSlide.querySelector('.gallery-slider__image-container');
        activeSlideCenter = activeSlideImage.offsetTop + (activeSlideImage.offsetHeight / 2);
    }

    sliderNext.style.top = activeSlideCenter + 'px';
    sliderNext.style.right = sliderNextRight + 'px';

    if(sliderNextRight <= 0) {
        sliderNext.style.right = 0;
    }

    sliderPrev.style.top = activeSlideCenter + 'px';
    sliderPrev.style.left = sliderPrevLeft + 'px';

    if(sliderPrevLeft <= 0) {
        sliderPrev.style.left = 0;
    }
}

const loopSliders = function(selector, enableTransitions) {
    const sliders = document.querySelectorAll(selector);

    for (let i = 0; i < sliders.length; i++) {
        const element = sliders[i];

        element.classList.add('no-trans');

        setGalleryArrowPos(element, selector);

        if(enableTransitions === true) {
            setTimeout(() => {
                element.classList.remove('no-trans');
            });
        }
    }
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        SimpleSlider.init();
        FluidSlider.init();
        GalleryLightbox.init();
        GalleryProgressSlider.init();

        $(GalleryProgressSlider.selector).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
            const slideCount = slick.slideCount - 1;
            const nextSlideIsFirst = currentSlide === slideCount;
            const nextSlideIsLast  = nextSlide === slideCount;
            const $activeSlide = $(slick.$slider[0]).find('.slick-active');
            const decl = currentSlide - nextSlide;
            let direction = null;

            if(decl == 1 || decl == (slideCount)*(-1) ) {
                direction = 'prev';
            } else {
                direction = 'next';
            }

            if (nextSlideIsFirst && direction === 'next') {
                $activeSlide.next('.slick-slide').addClass('slick-clone-current');
            }
            if (nextSlideIsLast && direction === 'prev') {
                $activeSlide.prev('.slick-slide').addClass('slick-clone-current');
            }
        });

        // Remove your custom active class active slide finished
        $(GalleryProgressSlider.selector).on('afterChange', function(e, slick, currentSlide, nextSlide) {
            const cloneCurrent = $(slick.$slider[0]).find('.slick-clone-current');
            cloneCurrent.removeClass('slick-clone-current');
        });

		$(FluidSlider.selector).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
            const slideCount = slick.slideCount - 1;
            const nextSlideIsFirst = currentSlide === slideCount;
            const nextSlideIsLast  = nextSlide === slideCount;
            const $activeSlide = $(slick.$slider[0]).find('.slick-active');
            const decl = currentSlide - nextSlide;
            let direction = null;

            if(decl == 1 || decl == (slideCount)*(-1) ) {
                direction = 'prev';
            } else {
                direction = 'next';
            }

            if (nextSlideIsFirst && direction === 'next') {
                $activeSlide.next('.slick-slide').addClass('slick-clone-current');
            }
            if (nextSlideIsLast && direction === 'prev') {
                $activeSlide.prev('.slick-slide').addClass('slick-clone-current');
            }
        });

        // Remove your custom active class active slide finished
        $(FluidSlider.selector).on('afterChange', function(e, slick, currentSlide, nextSlide) {
            const cloneCurrent = $(slick.$slider[0]).find('.slick-clone-current');
            cloneCurrent.removeClass('slick-clone-current');
        });
    },
    loaded() {
        loopSliders(GalleryProgressSlider.selector, true);
        loopSliders(SimpleSlider.selector, true);
        loopSliders(GalleryLightbox.selector, true);
        loopSliders(FluidSlider.selector, true);
    },
    resized() {
        GalleryLightbox.refreshSlider();

        clearInterval(resizeInterval);
        clearTimeout(resizeTimeout);

        loopSliders(GalleryProgressSlider.selector);
        loopSliders(SimpleSlider.selector);
        loopSliders(GalleryLightbox.selector);
        loopSliders(FluidSlider.selector);

        resizeInterval = setInterval(() => {
            loopSliders(GalleryProgressSlider.selector);
            loopSliders(SimpleSlider.selector);
            loopSliders(GalleryLightbox.selector);
            loopSliders(FluidSlider.selector);
        }, 10);

        resizeTimeout = setTimeout(() => {
            clearInterval(resizeInterval);
            loopSliders(GalleryProgressSlider.selector, true);
            loopSliders(SimpleSlider.selector, true);
            loopSliders(GalleryLightbox.selector, true);
            loopSliders(FluidSlider.selector, true);
        }, 250);
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
